/**
 * True only on known homepage URLs (not site-wide body classes).
 */
export default function isHomePage() {
  if (typeof window === "undefined" || !window.document) {
    return false;
  }

  const bodyId = ((document.body && document.body.id) || "").toLowerCase();
  if (bodyId === "homepage" || bodyId === "home-cs") {
    return true;
  }

  const path = (window.location.pathname || "")
    .replace(/\/+$/, "")
    .toLowerCase();

  if (!path || path === "/") {
    return true;
  }

  if (path === "/homepage" || path === "/homepage.html") {
    return true;
  }

  if (path === "/home-cs" || /\/home-cs(\.html)?$/i.test(path)) {
    return true;
  }

  return false;
}

/** Strip page hero on homepages only (e.g. CMS SSR inside the header). */
export function removeHomePageHeading() {
  if (!isHomePage()) {
    return;
  }

  const header = document.querySelector("#header-react header");
  const scope = header || document;

  scope.querySelectorAll("section#heading").forEach(node => {
    node.parentNode && node.parentNode.removeChild(node);
  });

  const mountSlot = document.querySelector(".header-heading-mount");
  if (mountSlot) {
    mountSlot.innerHTML = "";
  }
}
